import { render, staticRenderFns } from "./WinningTable.vue?vue&type=template&id=3d08c674&scoped=true&"
import script from "./WinningTable.vue?vue&type=script&lang=ts&"
export * from "./WinningTable.vue?vue&type=script&lang=ts&"
import style0 from "./WinningTable.vue?vue&type=style&index=0&id=3d08c674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d08c674",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/Romppu/source/repos/poker-serverless/pokerapp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
installComponents(component, {VCard,VCardTitle,VList,VListTile,VListTileContent})
